import api from "../../api"
import { submissionStatus } from "../../constants"

// Generic adapter for all type of collection

const collectionSubAdapter = {
  like: {
    responseBodyToRender(input = {}){
      let output = {}

      if(input){
        const {
          namaIndividu,
          imgFotoProfile,
          userId
        } = input

        output = {
          id: userId,
          name: namaIndividu,
          image: api.base_image + imgFotoProfile
        }
      }

      return output
    }
  }
}

const collectionAdapter = {
  responseBodyToByStatus(input){
    let output = []

    if(input){
      const logSubmission = {...input}
      const logSubmissionKeys = Object.keys(logSubmission)
      const logSubmissions = logSubmissionKeys.map(k => {
        return {
          id: k === 'all' ? k : submissionStatus[k],
          label: k,
          value: logSubmission[k]
        }
      })

      output = logSubmissions
    }

    return output;
  }
}

export { collectionAdapter, collectionSubAdapter }
